import type { OfferAppearance } from 'types/product';
import { formatDate } from 'utils/formatters';

export const defaultOfferAppearance = (): OfferAppearance => ({
  showListPrice: true,
  priceColor: null,
  badgeVisible: true,
  badgeLabel: '-{percent}%',
  badgeDisplay: 'chip',
  badgeVariant: 'filled',
  badgeColor: '#d32f2f',
  badgeTextColor: '#ffffff',
  badgeImageUrl: null,
  badgeImagePosition: 'bottomLeft',
  badgeImageSize: 64,
  badgeTextOnImage: true,
  promoLabel: 'Oferta',
  promoColor: '#d32f2f',
  promoTextColor: '#ffffff',
  showValidUntilOnDetail: true,
  showValidUntilOnCard: false,
  validUntilLabel: 'Válido hasta el {date}',
  customerBadgeVisible: true,
  customerBadgeLabel: '-{percent}%',
  customerBadgeVariant: 'filled',
  customerBadgeColor: '#1565c0',
  customerBadgeTextColor: '#ffffff',
});

export const normalizeOfferAppearance = (value?: Partial<OfferAppearance> | null): OfferAppearance => ({
  ...defaultOfferAppearance(),
  ...(value ?? {}),
});

/** La insignia de descuento va como cocarda sobre la foto (y no junto al precio). */
export const hasDiscount = (price: number, listPrice?: number, discountPercent?: number) =>
  Boolean(discountPercent && discountPercent > 0 && listPrice && listPrice > price);

export const isOfferOverlay = (look: OfferAppearance) =>
  look.badgeVisible && look.badgeDisplay === 'image' && Boolean(look.badgeImageUrl?.trim());

const formatPercent = (value: number) => new Intl.NumberFormat('es-AR', { maximumFractionDigits: 2 }).format(value);

export const offerBadgeText = (look: OfferAppearance, percent: number) =>
  look.badgeLabel.split('{percent}').join(formatPercent(percent));

export const offerValidUntilText = (look: OfferAppearance, date: string) =>
  look.validUntilLabel.split('{date}').join(formatDate(date));

export const customerBadgeText = (look: OfferAppearance, percent: number) =>
  look.customerBadgeLabel.split('{percent}').join(formatPercent(percent));
